import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  FlatList,
  TouchableOpacity,
  Image,
  TouchableHighlight,
  TextInput,
  ScrollView,
} from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { Picker } from "@react-native-picker/picker";
import Tooltip from "react-native-walkthrough-tooltip";
import { CommonButton } from "../../common/CommonButton";
import SelectDropdown from "react-native-select-dropdown";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { SwitchCommon } from "../../common/SwitchCommon";
import CreateEventTooltip from "../home-common-components/CreateEventTooltip";
import { AppImages } from "../../utility/AppImages";
import { toast } from "react-toastify";
import { s } from "react-native-size-matters";
import DateTimeComponent from "../ongoing-common-components/schedule-components/DateTimeComponent";
import DetermineStakeView from "./DetermineStakeView";

const PrivateEventCreateComponent = ({
  styles,
  challengeMode,
  arrDetermineStakes,
  setArrDetermineStakes,
  eventNameTooltipVisible,
  totalSteps,
  currentStep,
  setEventNameTooltipVisible,
  setGameTooltipVisible,
  handleNextStep,
  setEventName,
  eventName,
  numberOfBelts,
  setNumberOfBelts,
  setCornfirmPurchaseBeltModal,
  gameTooltipVisible,
  setDeviceTooltipVisible,
  games,
  setSelectGame,
  selectGame,
  allOrNothingSwitch,
  setAllOrNothingSwitch,
  tooltipForGift,
  setTooltipForGift,
  chatSwitch,
  setChatSwitch,
  resetCreateEventTooltips,
  settingTooltipVisible,
  twitchSwitch,
  handleTwitchSwitchToggle,
  youTubeSwitch,
  handleSwitchToggle,
  esquadifiSwitch,
  setEsquadifiSwitch,
  tooltipForEsquadifi,
  setTooltipForEsquadifi,
  deviceTooltipVisible,
  setGamerIdTooltipVisible,
  device,
  isOpen,
  setDevice,
  setIsOpen,
  openChild,
  setOpenChild,
  gamerID,
  setGamerID,
  handleNextStepFromGamerIdTooltip,
  descriptionTooltipVisible,
  setDescriptionTooltipVisible,
  setStakeTooltipVisible,
  tooltipVisible,
  setTooltipVisible,
  description,
  setDescription,
  pickImage,
  fileContent,
  stakeTooltipVisible,
  setDateTimeTooltipVisible,
  handleOrganiserAmountChange,
  organiserAmount,
  handleChallengerAmountChange,
  challengerAmount,
  dateTimeTooltipVisible,
  handleNextStepFromDateTimeTooltip,
  setShowDatePicker,
  setSelectDate,
  selectDate,
  selectTime,
  setSelectTime,
  handleSizeChange,
  size,
  setSize,
  handleDurationChange,
  hours,
  setHours,
  anticipatedTooltipVisible,
  setAnticipatedTooltipVisible,
  anticipatedCost,
  tokenRate,
  handleTokenTicketChange,
  tokenTicket,
  setTokenTicket,
  minTooltipVisible,
  setMinTooltipVisible,
  minAttendees,
  exclusiveTooltipVisible,
  setExclusiveTooltipVisible,
  setSettingTooltipVisible,
  gamerIdTooltipVisible,
  handleNextStepFromStakeTypeTooltip,
}) => {
  const deviceSize = useDeviceSize();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleConsoleClick = (console) => {
    setDevice(console);
    setIsOpen(false);
  };

  const handleParentClick = (parent) => {
    setOpenChild(openChild === parent ? null : parent);
  };
  const options = [
    { name: "PC" },
    { name: "XBOX", children: ["XBOX ONE", "X/S"] },
    { name: "Playstation", children: ["PS 4", "PS 5"] },
    { name: "Mobile" },
    { name: "CrossPlay", children: ["PC & Console", "Console Only"] },
  ];

  const [normalizedSelectGame, setNormalizedSelectGame] = useState("");

  useEffect(() => {
    const matchedGame = games.find(
      (game) => game.toLowerCase() === selectGame.toLowerCase()
    );

    if (matchedGame) {
      setNormalizedSelectGame(matchedGame);
    } else {
      setNormalizedSelectGame("");
    }
  }, [games, selectGame]);

  return (
    <>
      {/* Challenge Mode & Available Amount  */}
      <View
        style={[
          styles.challegeMode,
          {
            marginTop: 20,
          },
        ]}
      >
        <View
          style={{
            width:
              deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? "48%" : "100%",
          }}
        >
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_18,
              {
                color: AppColors.white,
              },
            ]}
          >
            Challenge Mode
          </Text>
          <View
            style={{
              // minWidth:
              //   deviceSize === DEVICE_SIZES.XS ||
              //   deviceSize === DEVICE_SIZES.SM ||
              //   deviceSize === DEVICE_SIZES.MD ||
              //   deviceSize === DEVICE_SIZES.LG
              //     ? "100%"
              //     : 641,
              height: 62,
              marginTop: 20,
              borderRadius: 12,
              borderWidth: 2,
              borderColor: AppColors.white,
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              padding: 3,
              overflow: "hidden",
            }}
          >
            <Picker
              selectedValue={challengeMode}
              aria-disabled={true}
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                styles.dropDownStyle,
                {
                  width: "100%",
                  textAlign: "center",
                  color: AppColors.appViolentColor_6D08C3,
                  fontSize: 18,
                  fontWeight: "500",
                  overflow: "hidden",
                  height: 60,
                  backgroundColor: AppColors.black_121212,
                },
              ]}
              // onValueChange={(itemValue, itemIndex) =>
              //   setChallengeMode(itemValue)
              // }
            >
              <Picker.Item
                style={[AppFontStyle.REGULAR_ANYBODY_16]}
                label="1 VS 1"
                value="1 VS 1"
              />
              {/* <Picker.Item
                    style={[AppFontStyle.REGULAR_ANYBODY_16]}
                    label="1 VS 2"
                    value="1 VS 2"
                  /> */}
            </Picker>
            <View
              style={{
                width: 25,
                height: 25,
                position: "absolute",
                right: 5,
                backgroundColor: AppColors.black_121212, // This should be the same color as your Picker's background color
              }}
            />
          </View>
        </View>
        <View
          style={{
            width:
              deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? "auto" : "100%",
          }}
        >
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_18,
              {
                color: AppColors.white,
              },
            ]}
          >
            Available Amount
          </Text>
          <View style={{ height: 100, marginTop: 20 }}>
            <FlatList
              horizontal={true}
              data={arrDetermineStakes}
              renderItem={({ item, index }) => {
                return (
                  <TouchableOpacity
                    style={{
                      height: 100,
                      width: 90,
                      backgroundColor: item.isAvailableAmountSelected
                        ? AppColors.black_999999
                        : AppColors.black_282828,
                      borderRadius: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onPress={() => {
                      const tempArr = [...arrDetermineStakes];
                      tempArr.forEach((element) => {
                        element.isAvailableAmountSelected = 0;
                      });
                      tempArr[0].isAvailableAmountSelected = 1;
                      setArrDetermineStakes(tempArr);
                    }}
                  >
                    <Image
                      // source={item.image}
                      source={{ uri: item.image }}
                      style={{
                        width: 50,
                        height: 50,
                        resizeMode: "contain",
                      }}
                    />
                    <Text
                      style={{
                        color: AppColors.white,
                        fontSize: 16,
                        fontWeight: "500",
                      }}
                    >
                      {item.name}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.white,
                        fontSize: 15,
                        fontWeight: "500",
                      }}
                    >
                      {item.value}
                    </Text>
                  </TouchableOpacity>
                );
              }}
              ItemSeparatorComponent={() => <View style={{ width: 10 }} />}
            />
          </View>
        </View>
      </View>
      {/* Event Details UI */}
      <View style={{ paddingTop: 16 }}>
        <View
          style={[
            styles.mainInputWrapper,
            {
              justifyContent: "space-between",
              flexDirection:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "column-reverse"
                  : "row",
            },
          ]}
        >
          {/* Event name */}
          <View style={styles.leftWrapper}>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.white },
              ]}
            >
              Event Details
            </Text>
            <View style={{ alignSelf: "flex-start" }}>
              <Tooltip
                isVisible={eventNameTooltipVisible}
                contentStyle={{
                  backgroundColor: AppColors.appBlueColor_3A5175,
                  width:
                    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 600 : 350,
                }}
                displayInsets={{
                  top: 0,
                  bottom: 0,
                  left:
                    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 240 : 10,
                  right: 0,
                }}
                arrowStyle={{
                  display: "none",
                }}
                content={
                  <View
                    style={{
                      backgroundColor: AppColors.appBlueColor_3A5175,
                      padding: 10,
                      gap: 10,
                    }}
                  >
                    <View
                      style={{
                        flex: 1,
                        gap:
                          deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                            ? 30
                            : 10,
                      }}
                    >
                      <View style={{ gap: 10 }}>
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_12,
                            { color: AppColors.white }, // Set text color for better readability
                          ]}
                        >
                          Choose a Name for Your Event 🏷️
                        </Text>
                        <View style={{ gap: 5, marginLeft: 10 }}>
                          <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                            • Give your event a memorable name to make it stand
                            out and grab attention from viewers and potential
                            challengers.
                          </Text>
                        </View>
                      </View>
                      {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 10,
                            alignItems: "flex-end",
                            justifyContent: "space-between",
                          }}
                        >
                          {/* Dots (Step Indicator) */}
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 5,
                              justifyContent: "center",
                              marginBottom: 10,
                            }}
                          >
                            {Array.from({ length: totalSteps }).map(
                              (_, index) => (
                                <View
                                  key={index}
                                  style={{
                                    height: 6,
                                    width: 6,
                                    borderRadius: 5,
                                    backgroundColor:
                                      currentStep === index
                                        ? AppColors.appViolentColor_6D08C3 // Active step color
                                        : AppColors.white, // Inactive step color
                                    borderWidth: 1,
                                    borderColor:
                                      currentStep === index
                                        ? AppColors.appViolentColor_6D08C3 // Active step color
                                        : AppColors.white,
                                  }}
                                />
                              )
                            )}
                          </View>

                          <Text
                            style={{
                              fontFamily: "Anybody_400Regular",
                              fontSize: 12,
                              color: AppColors.green_00FFE8,
                              marginBottom: 4,
                            }}
                          >
                            Click “Next” to start exploring the Create Event
                            Page.
                          </Text>

                          <TouchableOpacity
                            onPress={() => {
                              setEventNameTooltipVisible(false);
                              setGameTooltipVisible(true);
                              handleNextStep();
                            }}
                            style={{
                              backgroundColor: AppColors.appViolentColor_6D08C3,
                              width: 70,
                              height: 20,
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: 10,
                            }}
                          >
                            <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                              Next
                            </Text>
                          </TouchableOpacity>
                        </View>
                      ) : (
                        <View style={{ marginTop: 10 }}>
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 10,
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Dots (Step Indicator) */}
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 5,
                                alignItems: "center",
                              }}
                            >
                              {Array.from({ length: totalSteps }).map(
                                (_, index) => (
                                  <View
                                    key={index}
                                    style={{
                                      height: 6,
                                      width: 6,
                                      borderRadius: 5,
                                      backgroundColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3
                                          : AppColors.white,
                                      borderWidth: 1,
                                      borderColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3
                                          : AppColors.white,
                                    }}
                                  />
                                )
                              )}
                            </View>

                            <TouchableOpacity
                              onPress={() => {
                                setEventNameTooltipVisible(false);
                                setGameTooltipVisible(true);
                                handleNextStep();
                              }}
                              style={{
                                backgroundColor:
                                  AppColors.appViolentColor_6D08C3,
                                width: 70,
                                height: 20,
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 10,
                                cursor: "pointer",
                              }}
                            >
                              <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                Next
                              </Text>
                            </TouchableOpacity>
                          </View>
                          <Text
                            style={{
                              fontFamily: "Anybody_400Regular",
                              fontSize: 12,
                              color: AppColors.green_00FFE8,
                              marginTop: 15,
                            }}
                          >
                            Click “Next” to start exploring the Create Event
                            Page.
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>
                }
                placement="bottom"
              >
                <TouchableHighlight>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      styles.lableStyle,
                      {
                        paddingTop: 0,
                      },
                    ]}
                  >
                    Event name
                  </Text>
                </TouchableHighlight>
              </Tooltip>
            </View>
            <View style={[styles.inputWrapper]}>
              <TextInput
                placeholder={"My new streaming"}
                multiline={false}
                placeholderTextColor={AppColors.gray_C4C4C4}
                style={[AppFontStyle.REGULAR_ANYBODY_12, styles.textInputStyle]}
                // ref={refValue}
                onSubmitEditing={() => {}}
                onChangeText={setEventName}
                keyboardType="default"
                secureTextEntry={false}
                value={eventName}
              />
            </View>
          </View>

          <View
            style={{
              width:
                deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? "32%" : "100%",
            }}
          >
            <View style={{ marginBottom: 15 }}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: AppColors.white,
                  },
                ]}
              >
                Enter the number of belts
              </Text>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <TextInput
                  style={{
                    padding: 10,
                    paddingLeft: 0,
                    color: AppColors.gray_C3C3C3,
                    height: 40,
                    fontSize: 18,
                    alignItems: "center",
                  }}
                  placeholder="Enter number"
                  placeholderTextColor={AppColors.gray_C3C3C3}
                  value={numberOfBelts}
                  onChangeText={(text) => {
                    const strTextNumber = text.replace(/[^0-9]/, "");
                    const selectedBelt = arrDetermineStakes.filter(
                      (item) => item.isSelected
                    )[0];
                    if (!isNaN(+strTextNumber)) {
                      setNumberOfBelts(strTextNumber);
                    }
                  }}
                />
                <View>
                  <TouchableOpacity
                    style={{
                      paddingHorizontal: 5,
                      paddingVertical: 5,
                    }}
                    activeOpacity={0.5}
                    onPress={() => {
                      setNumberOfBelts((Number(numberOfBelts) + 1).toString());
                    }}
                  >
                    <Image
                      source={AppImages.icnUpPrice}
                      style={{
                        width: 10,
                        height: 10,
                        resizeMode: "contain",
                      }}
                    />
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={{
                      paddingHorizontal: 5,
                      paddingVertical: 5,
                    }}
                    activeOpacity={0.5}
                    onPress={() => {
                      if (Number(numberOfBelts) > 0) {
                        setNumberOfBelts(
                          (Number(numberOfBelts) - 1).toString()
                        );
                      }
                    }}
                  >
                    <Image
                      source={AppImages.icnDownPrice}
                      style={{
                        width: 10,
                        height: 10,
                        resizeMode: "contain",
                      }}
                    />
                  </TouchableOpacity>
                </View>
              </View>
            </View>
            <View style={{ alignItems: "flex-end" }}>
              <CommonButton
                buttonStyle={styles.buyBeltButtonStyle}
                textStyle={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  { color: AppColors.white },
                ]}
                title="Buy Belt"
                onTap={() => {
                  setCornfirmPurchaseBeltModal(true);
                }}
              />
            </View>
          </View>
        </View>
      </View>
      <View style={styles.divider} />
      <View style={{ position: "relative" }}>
        {/* Select the game */}
        <View style={styles.mainInputWrapper}>
          {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
            <View
              style={{
                alignSelf: "flex-start",
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "100%"
                    : "auto",
              }}
            >
              <Tooltip
                isVisible={gameTooltipVisible}
                contentStyle={{
                  backgroundColor: AppColors.appBlueColor_3A5175,
                  width: 600,
                }}
                displayInsets={{
                  top: 0,
                  bottom: 0,
                  left: 240,
                  right: 0,
                }}
                arrowStyle={{
                  display: "none",
                }}
                content={
                  <View
                    style={{
                      backgroundColor: AppColors.appBlueColor_3A5175,
                      padding: 10,
                      gap: 10,
                    }}
                  >
                    <View style={{ flex: 1, gap: 30 }}>
                      <View style={{ gap: 10 }}>
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_12,
                            { color: AppColors.white },
                          ]}
                        >
                          Select Game 🎮
                        </Text>
                        <View style={{ gap: 5, marginLeft: 10 }}>
                          <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                            • Pick the game and make sure everyone is ready and
                            prepared for the match.
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 10,
                          alignItems: "flex-end",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Dots (Step Indicator) */}
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 5,
                            justifyContent: "center",
                            marginBottom: 10,
                          }}
                        >
                          {Array.from({ length: totalSteps }).map(
                            (_, index) => (
                              <View
                                key={index}
                                style={{
                                  height: 6,
                                  width: 6,
                                  borderRadius: 5,
                                  backgroundColor:
                                    currentStep === index
                                      ? AppColors.appViolentColor_6D08C3 // Active step color
                                      : AppColors.white, // Inactive step color
                                  borderWidth: 1,
                                  borderColor:
                                    currentStep === index
                                      ? AppColors.appViolentColor_6D08C3 // Active step color
                                      : AppColors.white,
                                }}
                              />
                            )
                          )}
                        </View>

                        <Text
                          style={{
                            fontFamily: "Anybody_400Regular",
                            fontSize: 12,
                            color: AppColors.green_00FFE8,
                            marginBottom: 4,
                          }}
                        >
                          Click “Next” to start exploring the Create Event Page.
                        </Text>

                        <TouchableOpacity
                          onPress={() => {
                            setGameTooltipVisible(false);
                            setDeviceTooltipVisible(true);
                            handleNextStep();
                          }}
                          style={{
                            backgroundColor: AppColors.appViolentColor_6D08C3,
                            width: 70,
                            height: 20,
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 10,
                          }}
                        >
                          <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>
                }
                placement="bottom"
              >
                <TouchableHighlight>
                  <View style={styles.leftWrapper}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        styles.lableStyle,
                      ]}
                    >
                      Select the game
                    </Text>
                    <SelectDropdown
                      data={games}
                      onSelect={(selectedItem, index) => {
                        setSelectGame(selectedItem); // Set selected game title
                      }}
                      defaultValue={normalizedSelectGame}
                      renderButton={(selectedItem, isOpened) => {
                        return (
                          <View style={styles.dropdownButtonStyle}>
                            <Text
                              style={[
                                AppFontStyle.REGULAR_ANYBODY_12,
                                styles.dropdownButtonTxtStyle,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {selectedItem || "Select a game"}
                            </Text>
                            <Icon
                              name={isOpened ? "chevron-up" : "chevron-down"}
                              style={styles.dropdownButtonArrowStyle}
                            />
                          </View>
                        );
                      }}
                      renderItem={(item, index, isSelected) => {
                        return (
                          <View
                            style={{
                              ...styles.dropdownItemStyle,
                              ...(isSelected && {
                                backgroundColor: "#D2D9DF",
                              }),
                            }}
                          >
                            <Text style={styles.dropdownItemTxtStyle}>
                              {item}
                            </Text>
                          </View>
                        );
                      }}
                      search={true}
                      searchInputTxtColor={AppColors.white}
                      searchInputStyle={styles.searchInputStyle}
                      dropdownStyle={styles.dropdownMenuStyle}
                      showsVerticalScrollIndicator={false}
                    />
                  </View>
                </TouchableHighlight>
              </Tooltip>
            </View>
          ) : (
            <View style={styles.leftWrapper}>
              <View
                style={{
                  alignSelf: "flex-start",
                }}
              >
                <Tooltip
                  isVisible={gameTooltipVisible}
                  contentStyle={{
                    backgroundColor: AppColors.appBlueColor_3A5175,
                    width: 350,
                  }}
                  displayInsets={{
                    top: 0,
                    bottom: 0,
                    left: 10,
                    right: 0,
                  }}
                  arrowStyle={{
                    display: "none",
                  }}
                  content={
                    <View
                      style={{
                        backgroundColor: AppColors.appBlueColor_3A5175,
                        padding: 10,
                        gap: 10,
                      }}
                    >
                      <View style={{ flex: 1, gap: 10 }}>
                        <View style={{ gap: 10 }}>
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_12,
                              { color: AppColors.white },
                            ]}
                          >
                            Select Game 🎮
                          </Text>
                          <View style={{ gap: 5, marginLeft: 10 }}>
                            <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                              • Pick the game and make sure everyone is ready
                              and prepared for the match.
                            </Text>
                          </View>
                        </View>
                        <View style={{ marginTop: 10 }}>
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 10,
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Dots (Step Indicator) */}
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 5,
                                alignItems: "center",
                              }}
                            >
                              {Array.from({ length: totalSteps }).map(
                                (_, index) => (
                                  <View
                                    key={index}
                                    style={{
                                      height: 6,
                                      width: 6,
                                      borderRadius: 5,
                                      backgroundColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3
                                          : AppColors.white,
                                      borderWidth: 1,
                                      borderColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3
                                          : AppColors.white,
                                    }}
                                  />
                                )
                              )}
                            </View>

                            <TouchableOpacity
                              onPress={() => {
                                setGameTooltipVisible(false);
                                setDeviceTooltipVisible(true);
                                handleNextStep();
                              }}
                              style={{
                                backgroundColor:
                                  AppColors.appViolentColor_6D08C3,
                                width: 70,
                                height: 20,
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 10,
                                cursor: "pointer",
                              }}
                            >
                              <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                Next
                              </Text>
                            </TouchableOpacity>
                          </View>
                          <Text
                            style={{
                              fontFamily: "Anybody_400Regular",
                              fontSize: 12,
                              color: AppColors.green_00FFE8,
                              marginTop: 15,
                            }}
                          >
                            Click “Next” to start exploring the Create Event
                            Page.
                          </Text>
                        </View>
                      </View>
                    </View>
                  }
                  placement="bottom"
                >
                  <TouchableHighlight>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.lableStyle,
                      ]}
                    >
                      Select the game
                    </Text>
                  </TouchableHighlight>
                </Tooltip>
              </View>
              <SelectDropdown
                data={games}
                onSelect={(selectedItem, index) => {
                  setSelectGame(selectedItem); // Set selected game title
                }}
                defaultValue={normalizedSelectGame}
                renderButton={(selectedItem, isOpened) => {
                  return (
                    <View style={styles.dropdownButtonStyle}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          styles.dropdownButtonTxtStyle,
                          {
                            color: AppColors.white,
                          },
                        ]}
                      >
                        {selectedItem || "Select a game"}
                      </Text>
                      <Icon
                        name={isOpened ? "chevron-up" : "chevron-down"}
                        style={styles.dropdownButtonArrowStyle}
                      />
                    </View>
                  );
                }}
                renderItem={(item, index, isSelected) => {
                  return (
                    <View
                      style={{
                        ...styles.dropdownItemStyle,
                        ...(isSelected && {
                          backgroundColor: "#D2D9DF",
                        }),
                      }}
                    >
                      <Text style={styles.dropdownItemTxtStyle}>{item}</Text>
                    </View>
                  );
                }}
                search={true}
                searchInputTxtColor={AppColors.white}
                searchInputStyle={styles.searchInputStyle}
                dropdownStyle={styles.dropdownMenuStyle}
                showsVerticalScrollIndicator={false}
              />
            </View>
          )}

          {/* Select Console */}
          <View
            style={{
              width:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? "100%"
                  : 270,
              flexDirection: "column",
              gap: 12,
            }}
          >
            <View style={{ alignSelf: "flex-start" }}>
              <Tooltip
                isVisible={deviceTooltipVisible}
                contentStyle={{
                  backgroundColor: AppColors.appBlueColor_3A5175,
                  width:
                    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 600 : 350,
                }}
                displayInsets={{
                  top: 0,
                  bottom: 0,
                  left:
                    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 240 : 10,
                  right: 0,
                }}
                arrowStyle={{
                  display: "none",
                }}
                content={
                  <View
                    style={{
                      backgroundColor: AppColors.appBlueColor_3A5175,
                      padding: 10,
                      gap: 10,
                    }}
                  >
                    <View
                      style={{
                        flex: 1,
                        gap:
                          deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                            ? 30
                            : 10,
                      }}
                    >
                      <View style={{ gap: 10 }}>
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_12,
                            { color: AppColors.white }, // Set text color for better readability
                          ]}
                        >
                          Select Console 🎮
                        </Text>
                        <View style={{ gap: 5, marginLeft: 10 }}>
                          <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                            • Pick device (e.g., PC, console) and make sure
                            everyone is ready and prepared for the match.
                          </Text>
                        </View>
                      </View>
                      {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 10,
                            alignItems: "flex-end",
                            justifyContent: "space-between",
                          }}
                        >
                          {/* Dots (Step Indicator) */}
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 5,
                              justifyContent: "center",
                              marginBottom: 10,
                            }}
                          >
                            {Array.from({ length: totalSteps }).map(
                              (_, index) => (
                                <View
                                  key={index}
                                  style={{
                                    height: 6,
                                    width: 6,
                                    borderRadius: 5,
                                    backgroundColor:
                                      currentStep === index
                                        ? AppColors.appViolentColor_6D08C3 // Active step color
                                        : AppColors.white, // Inactive step color
                                    borderWidth: 1,
                                    borderColor:
                                      currentStep === index
                                        ? AppColors.appViolentColor_6D08C3 // Active step color
                                        : AppColors.white,
                                  }}
                                />
                              )
                            )}
                          </View>

                          <Text
                            style={{
                              fontFamily: "Anybody_400Regular",
                              fontSize: 12,
                              color: AppColors.green_00FFE8,
                              marginBottom: 4,
                            }}
                          >
                            Click “Next” to start exploring the Create Event
                            Page.
                          </Text>
                          <TouchableOpacity
                            onPress={() => {
                              setDeviceTooltipVisible(false);
                              setGamerIdTooltipVisible(true);
                              handleNextStep();
                            }}
                            style={{
                              backgroundColor: AppColors.appViolentColor_6D08C3,
                              width: 70,
                              height: 20,
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: 10,
                            }}
                          >
                            <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                              Next
                            </Text>
                          </TouchableOpacity>
                        </View>
                      ) : (
                        <View style={{ marginTop: 10 }}>
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 10,
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Dots (Step Indicator) */}
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 5,
                                alignItems: "center",
                              }}
                            >
                              {Array.from({ length: totalSteps }).map(
                                (_, index) => (
                                  <View
                                    key={index}
                                    style={{
                                      height: 6,
                                      width: 6,
                                      borderRadius: 5,
                                      backgroundColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3
                                          : AppColors.white,
                                      borderWidth: 1,
                                      borderColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3
                                          : AppColors.white,
                                    }}
                                  />
                                )
                              )}
                            </View>

                            <TouchableOpacity
                              onPress={() => {
                                setDeviceTooltipVisible(false);
                                setGamerIdTooltipVisible(true);
                                handleNextStep();
                              }}
                              style={{
                                backgroundColor:
                                  AppColors.appViolentColor_6D08C3,
                                width: 70,
                                height: 20,
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 10,
                                cursor: "pointer",
                              }}
                            >
                              <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                Next
                              </Text>
                            </TouchableOpacity>
                          </View>
                          <Text
                            style={{
                              fontFamily: "Anybody_400Regular",
                              fontSize: 12,
                              color: AppColors.green_00FFE8,
                              marginTop: 15,
                            }}
                          >
                            Click “Next” to start exploring the Create Event
                            Page.
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>
                }
                placement="bottom"
              >
                <TouchableHighlight>
                  <Text
                    style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
                  >
                    Select Console
                  </Text>
                </TouchableHighlight>
              </Tooltip>
            </View>
            <View style={{ position: "relative", zIndex: 999 }}>
              <TouchableOpacity onPress={toggleDropdown}>
                <View style={styles.dropdownButtonStyle}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      styles.dropdownButtonTxtStyle,
                      {
                        color: AppColors.white,
                      },
                    ]}
                  >
                    {device || "Select Console"}
                  </Text>
                  <Icon
                    name={isOpen ? "chevron-up" : "chevron-down"}
                    style={styles.dropdownButtonArrowStyle}
                  />
                </View>
              </TouchableOpacity>

              {isOpen && (
                <View
                  style={{
                    position: "absolute",
                    left: 0,
                    width: "100%",
                    top: 50,
                    borderWidth: 1,
                    borderColor: AppColors.white,
                    marginTop: 2,
                    backgroundColor: AppColors.black,
                    zIndex: 1000,
                    elevation: 10,
                  }}
                >
                  {options.map((option, idx) => (
                    <View key={idx}>
                      <TouchableOpacity
                        style={{
                          padding: 2,
                          borderBottomColor: AppColors.white,
                          borderBottomWidth: 1,
                          cursor: "pointer",
                          flexDirection: "row",
                        }}
                        onPress={() =>
                          option.children
                            ? handleParentClick(option.name)
                            : handleConsoleClick(option.name)
                        }
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.gray_C3C3C3,
                              paddingVertical: 14,
                              textAlign: "center",
                              flex: 1,
                            },
                          ]}
                        >
                          {option.name}
                        </Text>
                        {option.children && (
                          <Icon
                            name={
                              openChild === option.name
                                ? "chevron-up"
                                : "chevron-down"
                            }
                            style={styles.dropdownButtonArrowStyle}
                          />
                        )}
                      </TouchableOpacity>

                      {/* Accordion for child options */}
                      {openChild === option.name &&
                        option.children?.map((child, childIdx) => (
                          <TouchableOpacity
                            key={childIdx}
                            style={{
                              paddingLeft: 10,
                              paddingHorizontal: 20,
                              cursor: "pointer",
                              backgroundColor: AppColors.black,
                              borderBottomColor: AppColors.white,
                              borderBottomWidth: 1,
                            }}
                            onPress={() => handleConsoleClick(child)}
                          >
                            <Text
                              style={[
                                AppFontStyle.REGULAR_ANYBODY_12,
                                {
                                  color: AppColors.gray_C3C3C3,
                                  paddingVertical: 14,
                                  textAlign: "center",
                                },
                              ]}
                            >
                              {child}
                            </Text>
                          </TouchableOpacity>
                        ))}
                    </View>
                  ))}
                </View>
              )}
            </View>
          </View>
          <View
            style={[
              styles.rightWrapper,
              {
                flex: 1,
                position: "relative",
                zIndex: isOpen ? -1 : 100,
                elevation: 0,
              },
            ]}
          >
            <View style={{ alignSelf: "flex-start" }}>
              <Tooltip
                isVisible={gamerIdTooltipVisible}
                contentStyle={{
                  backgroundColor: AppColors.appBlueColor_3A5175,
                  width:
                    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 600 : 350,
                }}
                displayInsets={{
                  top: 0,
                  bottom: 0,
                  left: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 0 : 10,
                  right:
                    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 50 : 0,
                }}
                arrowStyle={{
                  display: "none",
                }}
                content={
                  <View
                    style={{
                      backgroundColor: AppColors.appBlueColor_3A5175,
                      padding: 10,
                      gap: 10,
                    }}
                  >
                    <View
                      style={{
                        flex: 1,
                        gap:
                          deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                            ? 30
                            : 10,
                      }}
                    >
                      <View style={{ gap: 10 }}>
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_12,
                            { color: AppColors.white }, // Set text color for better readability
                          ]}
                        >
                          Enter Your Gamer ID 🆔
                        </Text>
                        <View style={{ gap: 5, marginLeft: 10 }}>
                          <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                            • Add your Gamer ID so your opponent can easily find
                            you in the game. This makes for a smooth and
                            hassle-free connection.
                          </Text>
                        </View>
                      </View>
                      {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 10,
                            alignItems: "flex-end",
                            justifyContent: "space-between",
                          }}
                        >
                          {/* Dots (Step Indicator) */}
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 5,
                              justifyContent: "center",
                              marginBottom: 10,
                            }}
                          >
                            {Array.from({ length: totalSteps }).map(
                              (_, index) => (
                                <View
                                  key={index}
                                  style={{
                                    height: 6,
                                    width: 6,
                                    borderRadius: 5,
                                    backgroundColor:
                                      currentStep === index
                                        ? AppColors.appViolentColor_6D08C3 // Active step color
                                        : AppColors.white, // Inactive step color
                                    borderWidth: 1,
                                    borderColor:
                                      currentStep === index
                                        ? AppColors.appViolentColor_6D08C3 // Active step color
                                        : AppColors.white,
                                  }}
                                />
                              )
                            )}
                          </View>

                          <Text
                            style={{
                              fontFamily: "Anybody_400Regular",
                              fontSize: 12,
                              color: AppColors.green_00FFE8,
                              marginBottom: 4,
                            }}
                          >
                            Click “Next” to start exploring the Create Event
                            Page.
                          </Text>
                          <TouchableOpacity
                            onPress={() => {
                              setGamerIdTooltipVisible(false);
                              handleNextStepFromGamerIdTooltip();
                              handleNextStep();
                            }}
                            style={{
                              backgroundColor: AppColors.appViolentColor_6D08C3,
                              width: 70,
                              height: 20,
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: 10,
                            }}
                          >
                            <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                              Next
                            </Text>
                          </TouchableOpacity>
                        </View>
                      ) : (
                        <View style={{ marginTop: 10 }}>
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 10,
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Dots (Step Indicator) */}
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 5,
                                alignItems: "center",
                              }}
                            >
                              {Array.from({ length: totalSteps }).map(
                                (_, index) => (
                                  <View
                                    key={index}
                                    style={{
                                      height: 6,
                                      width: 6,
                                      borderRadius: 5,
                                      backgroundColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3
                                          : AppColors.white,
                                      borderWidth: 1,
                                      borderColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3
                                          : AppColors.white,
                                    }}
                                  />
                                )
                              )}
                            </View>

                            <TouchableOpacity
                              onPress={() => {
                                setGamerIdTooltipVisible(false);
                                handleNextStepFromGamerIdTooltip();
                                handleNextStep();
                              }}
                              style={{
                                backgroundColor:
                                  AppColors.appViolentColor_6D08C3,
                                width: 70,
                                height: 20,
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 10,
                                cursor: "pointer",
                              }}
                            >
                              <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                Next
                              </Text>
                            </TouchableOpacity>
                          </View>
                          <Text
                            style={{
                              fontFamily: "Anybody_400Regular",
                              fontSize: 12,
                              color: AppColors.green_00FFE8,
                              marginTop: 15,
                            }}
                          >
                            Click “Next” to start exploring the Create Event
                            Page.
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>
                }
                placement={
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                    ? "bottom"
                    : "top"
                }
              >
                <TouchableHighlight>
                  <Text
                    style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
                  >
                    Gamer ID
                  </Text>
                </TouchableHighlight>
              </Tooltip>
            </View>
            <View style={[styles.inputWrapper]}>
              <TextInput
                placeholder={"xxxxxxxx"}
                multiline={false}
                placeholderTextColor={AppColors.gray_C4C4C4}
                style={[AppFontStyle.REGULAR_ANYBODY_12, styles.textInputStyle]}
                // ref={refValue}
                onSubmitEditing={() => {}}
                onChange={(e) => {
                  const value = e.nativeEvent.text;
                  setGamerID(value);
                }}
                secureTextEntry={false}
                value={gamerID}
              />
            </View>
          </View>
        </View>
        {/* Thumbnail && Description  */}
        <View
          style={[
            styles.mainInputWrapper,
            {
              position: "relative",
              zIndex: isOpen ? -1 : 100,
              elevation: 0,
            },
          ]}
        >
          {/* Description */}
          {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
            <View
              style={{
                alignSelf: "flex-start",
                width: "auto",
              }}
            >
              <Tooltip
                isVisible={descriptionTooltipVisible}
                contentStyle={{
                  backgroundColor: AppColors.appBlueColor_3A5175,
                  width: 600,
                }}
                displayInsets={{
                  top: 0,
                  bottom: 0,
                  left: 250,
                  right: 0,
                }}
                arrowStyle={{
                  display: "none",
                }}
                content={
                  <View
                    style={{
                      backgroundColor: AppColors.appBlueColor_3A5175,
                      padding: 10,
                      gap: 10,
                    }}
                  >
                    <View style={{ flex: 1, gap: 30 }}>
                      <View style={{ gap: 10 }}>
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_12,
                            { color: AppColors.white },
                          ]}
                        >
                          Set the Rules & Game Mode ⚙️
                        </Text>
                        <View style={{ gap: 5, marginLeft: 10 }}>
                          <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                            • Define the rules and select the game mode. For the
                            best viewer experience, we recommend choosing a game
                            mode that lasts a minimum of 15 minutes to keep your
                            audience engaged and entertained.
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 10,
                          alignItems: "flex-end",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Dots (Step Indicator) */}
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 5,
                            justifyContent: "center",
                            marginBottom: 10,
                          }}
                        >
                          {Array.from({ length: totalSteps }).map(
                            (_, index) => (
                              <View
                                key={index}
                                style={{
                                  height: 6,
                                  width: 6,
                                  borderRadius: 5,
                                  backgroundColor:
                                    currentStep === index
                                      ? AppColors.appViolentColor_6D08C3 // Active step color
                                      : AppColors.white, // Inactive step color
                                  borderWidth: 1,
                                  borderColor:
                                    currentStep === index
                                      ? AppColors.appViolentColor_6D08C3 // Active step color
                                      : AppColors.white,
                                }}
                              />
                            )
                          )}
                        </View>

                        <Text
                          style={{
                            fontFamily: "Anybody_400Regular",
                            fontSize: 12,
                            color: AppColors.green_00FFE8,
                            marginBottom: 4,
                          }}
                        >
                          Click “Next” to start exploring the Create Event Page.
                        </Text>
                        <TouchableOpacity
                          onPress={() => {
                            setDescriptionTooltipVisible(false);
                            setStakeTooltipVisible(true);
                            handleNextStep();
                          }}
                          style={{
                            backgroundColor: AppColors.appViolentColor_6D08C3,
                            width: 70,
                            height: 20,
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 10,
                          }}
                        >
                          <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>
                }
                placement="bottom"
              >
                <TouchableHighlight>
                  <View
                    style={{
                      marginTop: 20,
                      width: 459,
                    }}
                  >
                    <View style={{ flexDirection: "row" }}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          styles.headerTitle,
                          { marginBottom: 12 },
                        ]}
                      >
                        Description & Rules
                      </Text>
                      <TouchableOpacity
                        onPress={() => {
                          setTooltipVisible(!tooltipVisible);
                        }}
                      >
                        <Image
                          source={{ uri: AppImages.icInfo }}
                          style={{
                            height: 20,
                            width: 20,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                      {tooltipVisible && (
                        <CreateEventTooltip
                          content={
                            "Please enter the rules you and your opponent will follow during the game. This can include any specific settings such as game mode, time limits, map/arena selection, banned items or characters, or any other custom rules. Ensure both players agree on the rules before confirming, as these will be final once the challenge is set. You can communicate with your opponent to adjust any details if needed before the game starts."
                          }
                          maxHeight={100}
                          // content={tag.title}
                          visible={tooltipVisible}
                          setVisible={setTooltipVisible}
                        />
                      )}
                    </View>
                    <View
                      style={[
                        styles.inputWrapper,
                        { flex: 1, paddingHorizontal: 0 },
                      ]}
                    >
                      <TextInput
                        placeholder={
                          "Please enter the rules you and your opponent will follow during the game. ......"
                        }
                        multiline={true}
                        placeholderTextColor={AppColors.gray_C4C4C4}
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          styles.textInputStyle,
                          {
                            marginBottom: 10,
                            verticalAlign: "top",
                            height: 105,
                          },
                        ]}
                        // ref={refValue}

                        onSubmitEditing={() => {}}
                        onChangeText={setDescription}
                        keyboardType="default"
                        secureTextEntry={false}
                        value={description}
                      />
                    </View>
                  </View>
                </TouchableHighlight>
              </Tooltip>
            </View>
          ) : (
            <View
              style={{
                marginTop: 20,
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.MD
                    ? "100%"
                    : 459,
              }}
            >
              <View style={{ flexDirection: "row" }}>
                <View
                  style={{
                    alignSelf: "flex-start",
                  }}
                >
                  <Tooltip
                    isVisible={descriptionTooltipVisible}
                    contentStyle={{
                      backgroundColor: AppColors.appBlueColor_3A5175,
                      width: 350,
                    }}
                    displayInsets={{
                      top: 0,
                      bottom: 0,
                      left: 10,
                      right: 0,
                    }}
                    arrowStyle={{
                      display: "none",
                    }}
                    content={
                      <View
                        style={{
                          backgroundColor: AppColors.appBlueColor_3A5175,
                          padding: 10,
                          gap: 10,
                        }}
                      >
                        <View style={{ flex: 1, gap: 10 }}>
                          <View style={{ gap: 10 }}>
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_12,
                                { color: AppColors.white }, // Set text color for better readability
                              ]}
                            >
                              Set the Rules & Game Mode ⚙️
                            </Text>
                            <View style={{ gap: 5, marginLeft: 10 }}>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                • Define the rules and select the game mode. For
                                the best viewer experience, we recommend
                                choosing a game mode that lasts a minimum of 15
                                minutes to keep your audience engaged and
                                entertained.
                              </Text>
                            </View>
                          </View>
                          <View style={{ marginTop: 10 }}>
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 10,
                                justifyContent: "space-between",
                              }}
                            >
                              {/* Dots (Step Indicator) */}
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 5,
                                  alignItems: "center",
                                }}
                              >
                                {Array.from({ length: totalSteps }).map(
                                  (_, index) => (
                                    <View
                                      key={index}
                                      style={{
                                        height: 6,
                                        width: 6,
                                        borderRadius: 5,
                                        backgroundColor:
                                          currentStep === index
                                            ? AppColors.appViolentColor_6D08C3
                                            : AppColors.white,
                                        borderWidth: 1,
                                        borderColor:
                                          currentStep === index
                                            ? AppColors.appViolentColor_6D08C3
                                            : AppColors.white,
                                      }}
                                    />
                                  )
                                )}
                              </View>

                              <TouchableOpacity
                                onPress={() => {
                                  setDescriptionTooltipVisible(false);
                                  setStakeTooltipVisible(true);
                                  handleNextStep();
                                }}
                                style={{
                                  backgroundColor:
                                    AppColors.appViolentColor_6D08C3,
                                  width: 70,
                                  height: 20,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: 10,
                                  cursor: "pointer",
                                }}
                              >
                                <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                  Next
                                </Text>
                              </TouchableOpacity>
                            </View>
                            <Text
                              style={{
                                fontFamily: "Anybody_400Regular",
                                fontSize: 12,
                                color: AppColors.green_00FFE8,
                                marginTop: 15,
                              }}
                            >
                              Click “Next” to start exploring the Create Public
                              Event Page.
                            </Text>
                          </View>
                        </View>
                      </View>
                    }
                    placement="bottom"
                  >
                    <TouchableHighlight>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          styles.headerTitle,
                          { marginBottom: 12 },
                        ]}
                      >
                        Description & Rules
                      </Text>
                    </TouchableHighlight>
                  </Tooltip>
                </View>
                <TouchableOpacity
                  onPress={() => {
                    setTooltipVisible(!tooltipVisible);
                  }}
                >
                  <Image
                    source={{ uri: AppImages.icInfo }}
                    style={{
                      height: 20,
                      width: 20,
                      resizeMode: "contain",
                    }}
                  />
                </TouchableOpacity>
                {tooltipVisible && (
                  <CreateEventTooltip
                    content={
                      "Please enter the rules you and your opponent will follow during the game. This can include any specific settings such as game mode, time limits, map/arena selection, banned items or characters, or any other custom rules. Ensure both players agree on the rules before confirming, as these will be final once the challenge is set. You can communicate with your opponent to adjust any details if needed before the game starts."
                    }
                    maxHeight={100}
                    // content={tag.title}
                    visible={tooltipVisible}
                    setVisible={setTooltipVisible}
                  />
                )}
              </View>
              <View
                style={[styles.inputWrapper, { flex: 1, paddingHorizontal: 0 }]}
              >
                <TextInput
                  placeholder={
                    "Please enter the rules you and your opponent will follow during the game. ......"
                  }
                  multiline={true}
                  placeholderTextColor={AppColors.gray_C4C4C4}
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    styles.textInputStyle,
                    {
                      marginBottom: 10,
                      verticalAlign: "top",
                      height: 105,
                    },
                  ]}
                  // ref={refValue}

                  onSubmitEditing={() => {}}
                  onChangeText={setDescription}
                  keyboardType="default"
                  secureTextEntry={false}
                  value={description}
                />
              </View>
            </View>
          )}
          {/* Thumbnail */}
          <View
            style={{
              marginTop: 20,
              width:
                deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ||
                deviceSize === DEVICE_SIZES.MD
                  ? "100%"
                  : 459,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_12,
                styles.headerTitle,
                { marginBottom: 12 },
              ]}
            >
              Upload image
            </Text>
            <TouchableOpacity
              activeOpacity={0.8}
              style={{
                flex: 1,
                borderRadius: 15,
                backgroundColor: AppColors.appGrayColor_1C1C1C,
                justifyContent: "center",
              }}
              onPress={pickImage}
            >
              <View style={styles.dragDropView}>
                {fileContent ? (
                  <View style={{}}>
                    <Image
                      source={{ uri: fileContent }}
                      style={{
                        width: 182,
                        height: 79,
                        alignSelf: "center",
                        resizeMode: "contain",
                      }}
                    />
                  </View>
                ) : (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 15,
                    }}
                  >
                    <Image
                      source={AppImages.icDragNDrop}
                      style={{
                        height: 40,
                        width: 40,
                        resizeMode: "contain",
                      }}
                    />
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.gray_C3C3C3,
                          flexWrap: "wrap",
                        },
                      ]}
                      numberOfLines={3}
                    >
                      Drag & drop file here
                    </Text>
                  </View>
                )}
                <TouchableOpacity
                  style={{
                    paddingHorizontal: 50,
                    backgroundColor: AppColors.appViolentColor_6D08C3,
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: 10,
                    paddingVertical: 10,
                  }}
                  onPress={() => {
                    pickImage();
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: AppColors.white },
                    ]}
                  >
                    Browse
                  </Text>
                </TouchableOpacity>
              </View>
            </TouchableOpacity>
          </View>
        </View>

        <View
          style={[
            styles.divider,
            {
              position: "relative",
              zIndex: isOpen ? -1 : 100,
              elevation: 0,
            },
          ]}
        />
        <View
          style={[
            styles.mainInputWrapper,
            {
              justifyContent: "space-between",
              position: "relative",
              zIndex: isOpen ? -1 : 100,
              elevation: 0,
            },
          ]}
        >
          {/*  Determining the Stakes */}
          <View>
            <View style={{ alignSelf: "flex-start" }}>
              <Tooltip
                isVisible={stakeTooltipVisible}
                contentStyle={{
                  backgroundColor: AppColors.appBlueColor_3A5175,
                  width:
                    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 600 : 350,
                }}
                displayInsets={{
                  top: 0,
                  bottom: 0,
                  left:
                    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 300 : 10,
                  right: 0,
                }}
                arrowStyle={{
                  display: "none",
                }}
                content={
                  <View
                    style={{
                      backgroundColor: AppColors.appBlueColor_3A5175,
                      padding: 10,
                      gap: 10,
                    }}
                  >
                    <View
                      style={{
                        flex: 1,
                        gap:
                          deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                            ? 30
                            : 10,
                      }}
                    >
                      <View style={{ gap: 10 }}>
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_12,
                            { color: AppColors.white },
                          ]}
                        >
                          Set the Wager 💰
                        </Text>
                        <View style={{ gap: 5, marginLeft: 10 }}>
                          <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                            • Add excitement by setting a wager in coins or
                            belts. This ups the stakes and adds a competitive
                            edge to your challenge! (Winner takes all)
                          </Text>
                        </View>
                      </View>
                      {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 10,
                            alignItems: "flex-end",
                            justifyContent: "space-between",
                          }}
                        >
                          {/* Dots (Step Indicator) */}
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 5,
                              justifyContent: "center",
                              marginBottom: 10,
                            }}
                          >
                            {Array.from({ length: totalSteps }).map(
                              (_, index) => (
                                <View
                                  key={index}
                                  style={{
                                    height: 6,
                                    width: 6,
                                    borderRadius: 5,
                                    backgroundColor:
                                      currentStep === index
                                        ? AppColors.appViolentColor_6D08C3 // Active step color
                                        : AppColors.white, // Inactive step color
                                    borderWidth: 1,
                                    borderColor:
                                      currentStep === index
                                        ? AppColors.appViolentColor_6D08C3 // Active step color
                                        : AppColors.white,
                                  }}
                                />
                              )
                            )}
                          </View>

                          <Text
                            style={{
                              fontFamily: "Anybody_400Regular",
                              fontSize: 12,
                              color: AppColors.green_00FFE8,
                              marginBottom: 4,
                            }}
                          >
                            Click “Next” to start exploring the Create Event
                            Page.
                          </Text>
                          <TouchableOpacity
                            onPress={() => {
                              setStakeTooltipVisible(false);
                              setDateTimeTooltipVisible(true);
                              handleNextStep();
                            }}
                            style={{
                              backgroundColor: AppColors.appViolentColor_6D08C3,
                              width: 70,
                              height: 20,
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: 10,
                            }}
                          >
                            <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                              Next
                            </Text>
                          </TouchableOpacity>
                        </View>
                      ) : (
                        <View style={{ marginTop: 10 }}>
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 10,
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Dots (Step Indicator) */}
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 5,
                                alignItems: "center",
                              }}
                            >
                              {Array.from({ length: totalSteps }).map(
                                (_, index) => (
                                  <View
                                    key={index}
                                    style={{
                                      height: 6,
                                      width: 6,
                                      borderRadius: 5,
                                      backgroundColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3
                                          : AppColors.white,
                                      borderWidth: 1,
                                      borderColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3
                                          : AppColors.white,
                                    }}
                                  />
                                )
                              )}
                            </View>

                            <TouchableOpacity
                              onPress={() => {
                                setStakeTooltipVisible(false);
                                handleNextStepFromStakeTypeTooltip();
                                handleNextStep();
                              }}
                              style={{
                                backgroundColor:
                                  AppColors.appViolentColor_6D08C3,
                                width: 70,
                                height: 20,
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 10,
                                cursor: "pointer",
                              }}
                            >
                              <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                Next
                              </Text>
                            </TouchableOpacity>
                          </View>
                          <Text
                            style={{
                              fontFamily: "Anybody_400Regular",
                              fontSize: 12,
                              color: AppColors.green_00FFE8,
                              marginTop: 15,
                            }}
                          >
                            Click “Next” to start exploring the Create Public
                            Event Page.
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>
                }
                placement={
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                    ? "bottom"
                    : "top"
                }
              >
                <TouchableHighlight>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_13,
                      styles.headerTitle,
                    ]}
                  >
                    Determining the Stakes
                  </Text>
                </TouchableHighlight>
              </Tooltip>
            </View>
            <View style={[styles.mainInputWrapper, { marginTop: s(6) }]}>
              <FlatList
                horizontal={true}
                data={arrDetermineStakes}
                keyExtractor={(item) => item.id.toString()}
                renderItem={({ item, index }) => (
                  <DetermineStakeView
                    item={item}
                    itemPress={() => {
                      const updatedArr = arrDetermineStakes.map(
                        (element, i) => {
                          if (i === index) {
                            return {
                              ...element,
                              isSelected: element.isSelected ? 0 : 1,
                            };
                          }
                          return element;
                        }
                      );
                      setArrDetermineStakes(updatedArr);
                    }}
                    upPress={() => {
                      const updatedArr = arrDetermineStakes.map(
                        (element, i) => {
                          if (i === index) {
                            if (element.numberOfSteaks + 1 > element.value) {
                              toast.error(
                                "Please select stakes within the available limit."
                              );
                              return element;
                            }
                            return {
                              ...element,
                              numberOfSteaks: element.numberOfSteaks + 1,
                              isSelected: 1,
                            };
                          }
                          return element;
                        }
                      );
                      setArrDetermineStakes(updatedArr);
                    }}
                    downPress={() => {
                      const updatedArr = arrDetermineStakes.map(
                        (element, i) => {
                          if (i === index) {
                            if (element.numberOfSteaks === 0) return element;
                            return {
                              ...element,
                              numberOfSteaks: element.numberOfSteaks - 1,
                              isSelected:
                                element.numberOfSteaks === 0
                                  ? 0
                                  : element.isSelected,
                            };
                          }
                          return element;
                        }
                      );
                      setArrDetermineStakes(updatedArr);
                    }}
                  />
                )}
                ItemSeparatorComponent={() => (
                  <View
                    style={{
                      width:
                        deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                          ? 75
                          : 20,
                    }}
                  />
                )}
                removeClippedSubviews={true}
                initialNumToRender={4}
                windowSize={10}
              />
            </View>
          </View>

          <View>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_14, styles.headerTitle]}>
              Profit from ticket sales
            </Text>
            <View
              style={{
                flexDirection:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "column"
                    : "row",
                gap:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 10
                    : 50,
              }}
            >
              {/* Kaller Percentage */}
              <View
                style={{
                  width:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? "100%"
                      : 155,
                }}
              >
                <Text
                  style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
                >
                  Kaller
                </Text>
                <View style={[styles.inputWrapper, { marginTop: s(6) }]}>
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <TextInput
                      multiline={false}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        styles.inputText,
                      ]}
                      onChange={(e) => {
                        let value = e.nativeEvent.text.replace("%", "");
                        handleOrganiserAmountChange(value);
                      }}
                      keyboardType="numeric"
                      secureTextEntry={false}
                      value={`${organiserAmount}%`}
                    />
                    <View style={{ alignSelf: "center" }}>
                      <TouchableOpacity
                        style={{
                          paddingHorizontal: 5,
                          paddingVertical: 5,
                        }}
                        activeOpacity={0.5}
                        onPress={() => {
                          if (organiserAmount < 100) {
                            const newAmount = organiserAmount + 1;
                            handleOrganiserAmountChange(newAmount);
                          }
                        }}
                      >
                        <Image
                          source={AppImages.icnUpPrice}
                          style={{
                            width: 14,
                            height: 14,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={{
                          paddingHorizontal: 5,
                          paddingVertical: 5,
                        }}
                        activeOpacity={0.5}
                        onPress={() => {
                          if (organiserAmount > 0) {
                            const newAmount = organiserAmount - 1;
                            handleOrganiserAmountChange(newAmount);
                          }
                        }}
                      >
                        <Image
                          source={AppImages.icnDownPrice}
                          style={{
                            width: 14,
                            height: 14,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>

              {/* Challenger Percentage */}
              <View
                style={{
                  width:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? "100%"
                      : 155,
                }}
              >
                <Text
                  style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
                >
                  Challenger
                </Text>
                <View style={[styles.inputWrapper, { marginTop: s(6) }]}>
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <TextInput
                      multiline={false}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        styles.inputText,
                      ]}
                      onChange={(e) => {
                        let value = e.nativeEvent.text.replace("%", "");
                        handleChallengerAmountChange(value);
                      }}
                      keyboardType="numeric"
                      secureTextEntry={false}
                      value={`${challengerAmount}%`}
                    />
                    <View style={{ alignSelf: "center" }}>
                      <TouchableOpacity
                        style={{
                          paddingHorizontal: 5,
                          paddingVertical: 5,
                        }}
                        activeOpacity={0.5}
                        onPress={() => {
                          if (challengerAmount < 100) {
                            const newAmount = challengerAmount + 1;
                            handleChallengerAmountChange(newAmount);
                          }
                        }}
                      >
                        <Image
                          source={AppImages.icnUpPrice}
                          style={{
                            width: 14,
                            height: 14,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={{
                          paddingHorizontal: 5,
                          paddingVertical: 5,
                        }}
                        activeOpacity={0.5}
                        onPress={() => {
                          if (challengerAmount > 0) {
                            const newAmount = challengerAmount - 1;
                            handleChallengerAmountChange(newAmount);
                          }
                        }}
                      >
                        <Image
                          source={AppImages.icnDownPrice}
                          style={{
                            width: 14,
                            height: 14,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>

        <View
          style={[
            styles.divider,
            {
              position: "relative",
              zIndex: isOpen ? -1 : 100,
              elevation: 0,
            },
          ]}
        />
      </View>
      {/*  Scheduling the Event */}
      <View>
        <View style={{ alignSelf: "flex-start" }}>
          <Tooltip
            isVisible={dateTimeTooltipVisible}
            contentStyle={{
              backgroundColor: AppColors.appBlueColor_3A5175,
              width: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 600 : 350,
            }}
            displayInsets={{
              top: 0,
              bottom: 0,
              left: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 300 : 10,
              right: 0,
            }}
            arrowStyle={{
              display: "none",
            }}
            content={
              <View
                style={{
                  backgroundColor: AppColors.appBlueColor_3A5175,
                  padding: 10,
                  gap: 10,
                }}
              >
                <View
                  style={{
                    flex: 1,
                    gap:
                      deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 30 : 10,
                  }}
                >
                  <View style={{ gap: 10 }}>
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_12,
                        { color: AppColors.white },
                      ]}
                    >
                      Set Time & Date 🕒
                    </Text>
                    <View style={{ gap: 5, marginLeft: 10 }}>
                      <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                        • Schedule the event by selecting a convenient date and
                        time. This ensures your audience and opponent can join
                        comfortably.
                      </Text>
                    </View>
                  </View>
                  {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                    <View
                      style={{
                        flexDirection: "row",
                        gap: 10,
                        alignItems: "flex-end",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* Dots (Step Indicator) */}
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 5,
                          justifyContent: "center",
                          marginBottom: 10,
                        }}
                      >
                        {Array.from({ length: totalSteps }).map((_, index) => (
                          <View
                            key={index}
                            style={{
                              height: 6,
                              width: 6,
                              borderRadius: 5,
                              backgroundColor:
                                currentStep === index
                                  ? AppColors.appViolentColor_6D08C3
                                  : AppColors.white,
                              borderWidth: 1,
                              borderColor:
                                currentStep === index
                                  ? AppColors.appViolentColor_6D08C3
                                  : AppColors.white,
                            }}
                          />
                        ))}
                      </View>

                      <Text
                        style={{
                          fontFamily: "Anybody_400Regular",
                          fontSize: 12,
                          color: AppColors.green_00FFE8,
                          marginBottom: 4,
                        }}
                      >
                        Click “Next” to start exploring the Create Event Page.
                      </Text>
                      <TouchableOpacity
                        onPress={() => {
                          setDateTimeTooltipVisible(false);
                          handleNextStepFromDateTimeTooltip();
                          handleNextStep();
                        }}
                        style={{
                          backgroundColor: AppColors.appViolentColor_6D08C3,
                          width: 70,
                          height: 20,
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: 10,
                        }}
                      >
                        <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
                      </TouchableOpacity>
                    </View>
                  ) : (
                    <View style={{ marginTop: 10 }}>
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 10,
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Dots (Step Indicator) */}
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 5,
                            alignItems: "center",
                          }}
                        >
                          {Array.from({ length: totalSteps }).map(
                            (_, index) => (
                              <View
                                key={index}
                                style={{
                                  height: 6,
                                  width: 6,
                                  borderRadius: 5,
                                  backgroundColor:
                                    currentStep === index
                                      ? AppColors.appViolentColor_6D08C3
                                      : AppColors.white,
                                  borderWidth: 1,
                                  borderColor:
                                    currentStep === index
                                      ? AppColors.appViolentColor_6D08C3
                                      : AppColors.white,
                                }}
                              />
                            )
                          )}
                        </View>

                        <TouchableOpacity
                          onPress={() => {
                            setDateTimeTooltipVisible(false);
                            handleNextStepFromDateTimeTooltip();
                            handleNextStep();
                          }}
                          style={{
                            backgroundColor: AppColors.appViolentColor_6D08C3,
                            width: 70,
                            height: 20,
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 10,
                            cursor: "pointer",
                          }}
                        >
                          <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
                        </TouchableOpacity>
                      </View>
                      <Text
                        style={{
                          fontFamily: "Anybody_400Regular",
                          fontSize: 12,
                          color: AppColors.green_00FFE8,
                          marginTop: 15,
                        }}
                      >
                        Click “Next” to start exploring the Create Public Event
                        Page.
                      </Text>
                    </View>
                  )}
                </View>
              </View>
            }
            placement="bottom"
          >
            <TouchableHighlight>
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_14, styles.headerTitle]}
              >
                Scheduling the Event
              </Text>
            </TouchableHighlight>
          </Tooltip>
        </View>
        <View style={styles.mainInputWrapper}>
          <DateTimeComponent
            index={1}
            title=""
            styles={styles}
            setShowDatePicker={setShowDatePicker}
            setSelectDate={setSelectDate}
            selectDate={selectDate}
            setSelectTime={setSelectTime}
            selectTime={selectTime}
            type="createEvent"
            dateTitle="Select date"
            timeTitle="Select time"
          />
        </View>
      </View>
      <View style={styles.divider} />
      {/* Set up ticket system */}
      <View style={styles.mainInputWrapper}>
        <View style={{ width: "100%" }}>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_14, styles.lableStyle]}>
            Set up ticket system
          </Text>
          <View
            style={[
              styles.mainInputWrapper,
              {
                alignItems: "flex-end",
              },
            ]}
          >
            {/* Select anticipated audience size: */}
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "100%"
                    : 155,
                gap: 12,
              }}
            >
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
              >
                Select anticipated audience size:
              </Text>
              <View style={[styles.inputWrapper, {}]}>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextInput
                    multiline={false}
                    style={[AppFontStyle.REGULAR_ANYBODY_12, styles.inputText]}
                    onChange={(e) => handleSizeChange(e.nativeEvent.text)}
                    keyboardType="numeric"
                    secureTextEntry={false}
                    value={`${size}`}
                  />
                  <View style={{ alignSelf: "center" }}>
                    <TouchableOpacity
                      style={{ paddingHorizontal: 5, paddingVertical: 5 }}
                      activeOpacity={0.5}
                      onPress={() => {
                        setSize(size + 1);
                      }}
                    >
                      <Image
                        source={AppImages.icnUpPrice}
                        style={{
                          width: 14,
                          height: 14,
                          resizeMode: "contain",
                        }}
                      />
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={{ paddingHorizontal: 5, paddingVertical: 5 }}
                      activeOpacity={0.5}
                      onPress={() => {
                        if (size > 1) setSize(size - 1);
                      }}
                    >
                      <Image
                        source={AppImages.icnDownPrice}
                        style={{
                          width: 14,
                          height: 14,
                          resizeMode: "contain",
                        }}
                      />
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            </View>

            {/* Duration */}
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "100%"
                    : "auto",
                gap: 12,
              }}
            >
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
              >
                Duration
              </Text>
              <View style={[styles.inputWrapper, {}]}>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextInput
                    multiline={false}
                    style={[AppFontStyle.REGULAR_ANYBODY_12, styles.inputText]}
                    onChange={(e) => handleDurationChange(e.nativeEvent.text)}
                    keyboardType="numeric"
                    secureTextEntry={false}
                    value={`${hours} hours`}
                  />
                  <View style={{ alignSelf: "center" }}>
                    <TouchableOpacity
                      style={{ paddingHorizontal: 5, paddingVertical: 5 }}
                      activeOpacity={0.5}
                      onPress={() => {
                        if (hours < 24) setHours(hours + 1);
                      }}
                    >
                      <Image
                        source={AppImages.icnUpPrice}
                        style={{
                          width: 14,
                          height: 14,
                          resizeMode: "contain",
                        }}
                      />
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={{ paddingHorizontal: 5, paddingVertical: 5 }}
                      activeOpacity={0.5}
                      onPress={() => {
                        if (hours > 1) setHours(hours - 1);
                      }}
                    >
                      <Image
                        source={AppImages.icnDownPrice}
                        style={{
                          width: 14,
                          height: 14,
                          resizeMode: "contain",
                        }}
                      />
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            </View>

            {/* Anticipated Cost */}
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "100%"
                    : 225,
                gap: 12,
              }}
            >
              <View style={{ flexDirection: "row" }}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { paddingTop: 14, color: AppColors.red_FA0A0A },
                  ]}
                >
                  Anticipated cost of stream
                </Text>
                <TouchableOpacity
                  onPress={() => {
                    setAnticipatedTooltipVisible(!anticipatedTooltipVisible);
                  }}
                >
                  <Image
                    source={{ uri: AppImages.icInfo }}
                    style={{
                      height: 20,
                      width: 20,
                      resizeMode: "contain",
                    }}
                  />
                </TouchableOpacity>
                {anticipatedTooltipVisible && (
                  <CreateEventTooltip
                    width={
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? "auto"
                        : 500
                    }
                    maxHeight={100}
                    content={`Minimum Number of Attendees
The minimum number of attendees is the least number of participants who need to purchase tickets (using tokens) to cover the cost of hosting and streaming your event.
What does it mean?
- This number ensures that all your event costs (such as streaming, platform fees, and additional services) are covered by ticket sales in tokens.
- If you don't reach this number, you may need to cover some of the event costs yourself.
How it's calculated:
- Based on the total event cost in tokens and the price you've set for each ticket (also in tokens).
Why is it important?
- Knowing the minimum attendees helps you set the right token price for tickets and determine how many participants you need for a successful event.
Example:
- If your event costs 500 tokens to run, and you set the ticket price at 10 tokens per person, you'll need at least 50 attendees to cover the event cost.
Pro Tip:
- You can raise the ticket price (in tokens) to reduce the required number of attendees, or lower the streaming/event costs to make it more affordable.`}
                    visible={anticipatedTooltipVisible}
                    setVisible={setAnticipatedTooltipVisible}
                  />
                )}
              </View>
              <View
                style={[
                  styles.inputWrapper,
                  {
                    flex: 1,
                    justifyContent: "center",
                    paddingVertical: 4,
                  },
                ]}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>
                    {anticipatedCost} Tokens
                  </Text>
                  <View
                    style={{
                      borderColor: AppColors.white,
                      borderWidth: 1,
                      height: 40,
                    }}
                  ></View>
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>
                    ${(anticipatedCost * tokenRate).toFixed(2)}
                  </Text>
                </View>
              </View>
            </View>

            {/* Ticket price in Tokens */}
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "100%"
                    : 270,
                gap: 12,
              }}
            >
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
              >
                Ticket price
              </Text>
              <View style={[styles.inputWrapper, {}]}>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextInput
                    multiline={false}
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_18,
                      styles.inputText,
                      {},
                    ]}
                    onChange={(e) => {
                      handleTokenTicketChange(e.nativeEvent.text);
                    }}
                    keyboardType="numeric"
                    secureTextEntry={false}
                    value={`${tokenTicket}`}
                  />
                  <View style={{ flexDirection: "row" }}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_18,
                        {
                          color: AppColors.white,
                          alignSelf: "center",
                          marginRight: 20,
                        },
                      ]}
                    >
                      Tokens
                    </Text>
                    <View style={{ alignSelf: "center" }}>
                      <TouchableOpacity
                        style={{
                          paddingHorizontal: 5,
                          paddingVertical: 5,
                        }}
                        activeOpacity={0.5}
                        onPress={() => setTokenTicket(tokenTicket + 1)}
                      >
                        <Image
                          source={AppImages.icnUpPrice}
                          style={{
                            width: 14,
                            height: 14,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={{
                          paddingHorizontal: 5,
                          paddingVertical: 5,
                        }}
                        activeOpacity={0.5}
                        onPress={() => {
                          if (tokenTicket > 0) setTokenTicket(tokenTicket - 1);
                        }}
                      >
                        <Image
                          source={AppImages.icnDownPrice}
                          style={{
                            width: 14,
                            height: 14,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>
            </View>

            {/* Ticket price in USD */}
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "100%"
                    : 155,
                gap: 12,
              }}
            >
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
              >
                Ticket price (USD)
              </Text>
              <View
                style={[
                  styles.inputWrapper,
                  {
                    flex: 1,
                    justifyContent: "center",
                    paddingVertical: 18,
                  },
                ]}
              >
                <Text
                  style={[AppFontStyle.REGULAR_ANYBODY_12, styles.inputText]}
                >
                  ${(tokenTicket * tokenRate).toFixed(2)} USD
                </Text>
              </View>
            </View>

            {/* Min Required Attendees */}
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "100%"
                    : 160,
                gap: 12,
              }}
            >
              <View style={{ flexDirection: "row" }}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { paddingTop: 14, color: AppColors.red_FA0A0A },
                  ]}
                >
                  Min required attendees
                </Text>
                <TouchableOpacity
                  onPress={() => {
                    setMinTooltipVisible(!minTooltipVisible);
                  }}
                >
                  <Image
                    source={{ uri: AppImages.icInfo }}
                    style={{
                      height: 20,
                      width: 20,
                      resizeMode: "contain",
                    }}
                  />
                </TouchableOpacity>
                {minTooltipVisible && (
                  <CreateEventTooltip
                    width={
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? "auto"
                        : 500
                    }
                    maxHeight={100}
                    content={`Minimum Number of Attendees
The minimum number of attendees is the least number of participants who need to purchase tickets (using tokens) to cover the cost of hosting and streaming your event.
What does it mean?
- This number ensures that all your event costs (such as streaming, platform fees, and additional services) are covered by ticket sales in tokens.
- If you don't reach this number, you may need to cover some of the event costs yourself.
How it's calculated:
- Based on the total event cost in tokens and the price you've set for each ticket (also in tokens).
Why is it important?
- Knowing the minimum attendees helps you set the right token price for tickets and determine how many participants you need for a successful event.
Example:
- If your event costs 500 tokens to run, and you set the ticket price at 10 tokens per person, you'll need at least 50 attendees to cover the event cost.
Pro Tip:
- You can raise the ticket price (in tokens) to reduce the required number of attendees, or lower the streaming/event costs to make it more affordable.`}
                    visible={minTooltipVisible}
                    setVisible={setMinTooltipVisible}
                  />
                )}
              </View>
              <View
                style={[
                  styles.inputWrapper,

                  {
                    flex: 1,
                    justifyContent: "center",
                    paddingVertical: 18,
                  },
                ]}
              >
                <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>
                  {minAttendees}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </View>
      <View
        style={{
          width:
            deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.MD
              ? "100%"
              : "80%",
        }}
      >
        <View style={styles.divider} />
        <View style={styles.divider} />
        <View style={styles.divider} />

        {/* Live Streaming Setup */}
        <View style={styles.divider} />
        <View style={styles.mainInputWrapper}>
          <View style={{ width: "100%" }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingBottom: 10,
              }}
            >
              <View style={{ alignSelf: "flex-start" }}>
                <Tooltip
                  isVisible={exclusiveTooltipVisible}
                  contentStyle={{
                    backgroundColor: AppColors.appBlueColor_3A5175,
                    width:
                      deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                        ? 600
                        : 350,
                  }}
                  displayInsets={{
                    top:
                      deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 0 : 10,
                    bottom: 0,
                    left:
                      deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 300 : 10,
                    right: 0,
                  }}
                  arrowStyle={{
                    display: "none",
                  }}
                  content={
                    <ScrollView
                      style={{
                        flex: 1,
                      }}
                    >
                      <View
                        style={{
                          backgroundColor: AppColors.appBlueColor_3A5175,
                          padding: 10,
                          gap: 10,
                        }}
                      >
                        <View
                          style={{
                            flex: 1,
                            gap:
                              deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                                ? 30
                                : 10,
                          }}
                        >
                          <View style={{ gap: 10 }}>
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_12,
                                { color: AppColors.white },
                              ]}
                            >
                              Exclusive Streaming on Esquadifi 🔒
                            </Text>
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_12,
                                { color: AppColors.white },
                              ]}
                            >
                              • For Exclusive Events, Esquadifi’s streaming
                              service provides a private, ticketed viewing
                              experience. Here’s what makes it special:
                            </Text>
                            <View style={{ gap: 5, marginLeft: 10 }}>
                              <Text
                                style={[
                                  AppFontStyle.REGULAR_ANYBODY_12,
                                  { color: AppColors.green_00FFE8 },
                                ]}
                              >
                                a. Ticketed Access 🎟️
                              </Text>
                            </View>
                            <View style={{ gap: 5, marginLeft: 20 }}>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                • Only ticket holders can watch the live stream,
                                making your event exclusive and secure.
                              </Text>
                            </View>
                            <View style={{ gap: 5, marginLeft: 10 }}>
                              <Text
                                style={[
                                  AppFontStyle.REGULAR_ANYBODY_12,
                                  { color: AppColors.green_00FFE8 },
                                ]}
                              >
                                b. Centralised Audience Engagement 💬
                              </Text>
                            </View>
                            <View style={{ gap: 5, marginLeft: 20 }}>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                • Viewers watch directly on Esquadifi, where
                                they can interact through chat, cheer, and send
                                gifts, creating a lively, focused experience for
                                paying attendees.
                              </Text>
                            </View>
                            <View style={{ gap: 5, marginLeft: 10 }}>
                              <Text
                                style={[
                                  AppFontStyle.REGULAR_ANYBODY_12,
                                  { color: AppColors.green_00FFE8 },
                                ]}
                              >
                                c. High-Value Content 💰
                              </Text>
                            </View>
                            <View style={{ gap: 5, marginLeft: 20 }}>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                • Exclusive streaming on Esquadifi allows
                                organisers to generate revenue from ticket sales
                                while offering a premium experience for
                                dedicated fans.
                              </Text>
                            </View>
                          </View>
                          {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 10,
                                alignItems: "flex-end",
                                justifyContent: "space-between",
                              }}
                            >
                              {/* Dots (Step Indicator) */}
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 5,
                                  justifyContent: "center",
                                  marginBottom: 10,
                                }}
                              >
                                {Array.from({ length: totalSteps }).map(
                                  (_, index) => (
                                    <View
                                      key={index}
                                      style={{
                                        height: 6,
                                        width: 6,
                                        borderRadius: 5,
                                        backgroundColor:
                                          currentStep === index
                                            ? AppColors.appViolentColor_6D08C3 // Active step color
                                            : AppColors.white, // Inactive step color
                                        borderWidth: 1,
                                        borderColor:
                                          currentStep === index
                                            ? AppColors.appViolentColor_6D08C3 // Active step color
                                            : AppColors.white,
                                      }}
                                    />
                                  )
                                )}
                              </View>

                              <Text
                                style={{
                                  fontFamily: "Anybody_400Regular",
                                  fontSize: 12,
                                  color: AppColors.green_00FFE8,
                                  marginBottom: 4,
                                }}
                              >
                                Click “Let’s Go” to stop tutorial.
                              </Text>
                              <TouchableOpacity
                                onPress={() => {
                                  setExclusiveTooltipVisible(false);
                                  setSettingTooltipVisible(true);
                                  handleNextStep();
                                }}
                                style={{
                                  backgroundColor:
                                    AppColors.appViolentColor_6D08C3,
                                  width: 70,
                                  height: 20,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: 10,
                                }}
                              >
                                <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                  Next
                                </Text>
                              </TouchableOpacity>
                            </View>
                          ) : (
                            <View style={{ marginTop: 10 }}>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                {/* Dots (Step Indicator) */}
                                <View
                                  style={{
                                    flexDirection: "row",
                                    gap: 5,
                                    alignItems: "center",
                                  }}
                                >
                                  {Array.from({ length: totalSteps }).map(
                                    (_, index) => (
                                      <View
                                        key={index}
                                        style={{
                                          height: 6,
                                          width: 6,
                                          borderRadius: 5,
                                          backgroundColor:
                                            currentStep === index
                                              ? AppColors.appViolentColor_6D08C3
                                              : AppColors.white,
                                          borderWidth: 1,
                                          borderColor:
                                            currentStep === index
                                              ? AppColors.appViolentColor_6D08C3
                                              : AppColors.white,
                                        }}
                                      />
                                    )
                                  )}
                                </View>

                                <TouchableOpacity
                                  onPress={() => {
                                    setExclusiveTooltipVisible(false);
                                    setSettingTooltipVisible(true);
                                    handleNextStep();
                                  }}
                                  style={{
                                    backgroundColor:
                                      AppColors.appViolentColor_6D08C3,
                                    width: 70,
                                    height: 20,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: 10,
                                    cursor: "pointer",
                                  }}
                                >
                                  <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                    Next
                                  </Text>
                                </TouchableOpacity>
                              </View>
                              <Text
                                style={{
                                  fontFamily: "Anybody_400Regular",
                                  fontSize: 12,
                                  color: AppColors.green_00FFE8,
                                  marginTop: 15,
                                }}
                              >
                                Click “Next” to start exploring the Create
                                Public Event Page.
                              </Text>
                            </View>
                          )}
                        </View>
                      </View>
                    </ScrollView>
                  }
                  placement={"top"}
                >
                  <TouchableHighlight>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        styles.headerTitle,
                      ]}
                    >
                      Live Streaming Setup
                    </Text>
                  </TouchableHighlight>
                </Tooltip>
              </View>

              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_14, styles.headerTitle]}
              >
                Enable/disable
              </Text>
            </View>

            <View style={{ gap: 5 }}>
              {/* Esquadifi */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <View style={{ flexDirection: "row" }}>
                  <Text
                    style={[AppFontStyle.REGULAR_ANYBODY_14, styles.lableStyle]}
                  >
                    Esquadifi
                  </Text>
                  <TouchableOpacity
                    onPress={() => {
                      setTooltipForEsquadifi(!tooltipForEsquadifi);
                    }}
                  >
                    <Image
                      source={{ uri: AppImages.icInfo }}
                      style={{
                        height: 20,
                        width: 20,
                        resizeMode: "contain",
                      }}
                    />
                  </TouchableOpacity>
                  {tooltipForEsquadifi && (
                    <CreateEventTooltip
                      right={-30}
                      content={" Compete Without Streaming"}
                      maxHeight={100}
                      // content={tag.title}
                      visible={tooltipForEsquadifi}
                      setVisible={setTooltipForEsquadifi}
                    />
                  )}
                </View>
                <SwitchCommon
                  switchState={esquadifiSwitch}
                  setSwitchState={setEsquadifiSwitch}
                />
              </View>
              {/* Youtube */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text
                  style={[AppFontStyle.REGULAR_ANYBODY_14, styles.lableStyle]}
                >
                  Youtube
                </Text>
                <SwitchCommon
                  switchState={youTubeSwitch}
                  setSwitchState={handleSwitchToggle}
                />
              </View>
              {/* Twtich */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text
                  style={[AppFontStyle.REGULAR_ANYBODY_14, styles.lableStyle]}
                >
                  Twitch
                </Text>
                <SwitchCommon
                  switchState={twitchSwitch}
                  setSwitchState={handleTwitchSwitchToggle}
                />
              </View>
            </View>

            {/* <View
              style={{
                flexDirection: "row",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  { color: AppColors.appViolentColor_6D08C3 },
                ]}
              >
                Show more
              </Text>
            </View> */}
          </View>
        </View>

        {/* Stream Settings */}
        <View style={styles.divider} />
        <View style={styles.mainInputWrapper}>
          <View style={{ width: "100%" }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingBottom: 10,
              }}
            >
              <View style={{ alignSelf: "flex-start" }}>
                <Tooltip
                  isVisible={settingTooltipVisible}
                  contentStyle={{
                    backgroundColor: AppColors.appBlueColor_3A5175,
                    width:
                      deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                        ? 600
                        : 350,
                  }}
                  displayInsets={{
                    top: 0,
                    bottom: 0,
                    left:
                      deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 300 : 10,
                    right: 0,
                  }}
                  arrowStyle={{
                    display: "none",
                  }}
                  content={
                    <View
                      style={{
                        backgroundColor: AppColors.appBlueColor_3A5175,
                        padding: 10,
                        gap: 10,
                      }}
                    >
                      <View
                        style={{
                          flex: 1,
                          gap:
                            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                              ? 30
                              : 10,
                        }}
                      >
                        <View style={{ gap: 10 }}>
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_12,
                              { color: AppColors.white }, // Set text color for better readability
                            ]}
                          >
                            Stream Settings ⚙️
                          </Text>
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_12,
                              { color: AppColors.white }, // Set text color for better readability
                            ]}
                          >
                            • Customise your stream settings to make your event
                            more interactive and exciting for both players and
                            the audience. Here’s what each option does:
                          </Text>
                          <View style={{ gap: 5, marginLeft: 10 }}>
                            <Text
                              style={[
                                AppFontStyle.REGULAR_ANYBODY_12,
                                { color: AppColors.green_00FFE8 },
                              ]}
                            >
                              a. Chat 💬
                            </Text>
                          </View>
                          <View style={{ gap: 5, marginLeft: 20 }}>
                            <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                              <Text style={{ color: AppColors.green_00FFE8 }}>
                                • Enable Chat:
                              </Text>{" "}
                              Toggle this on to allow the audience to chat and
                              engage with each other as they watch the players
                              compete. This boosts excitement and keeps the
                              audience involved throughout the event.
                            </Text>
                          </View>
                          <View style={{ gap: 5, marginLeft: 10 }}>
                            <Text
                              style={[
                                AppFontStyle.REGULAR_ANYBODY_12,
                                { color: AppColors.green_00FFE8 },
                              ]}
                            >
                              b. All or Nothing 🎁
                            </Text>
                          </View>
                          <View style={{ gap: 5, marginLeft: 20 }}>
                            <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                              <Text style={{ color: AppColors.green_00FFE8 }}>
                                • Winner Takes All:
                              </Text>{" "}
                              When this is enabled, the winner of the event
                              takes home not only the wager but also all the
                              gifts sent by the audience during the stream. It
                              adds a thrilling, high-stakes element to the
                              competition.
                            </Text>
                          </View>
                        </View>
                        {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 10,
                              alignItems: "flex-end",
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Dots (Step Indicator) */}
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 5,
                                justifyContent: "center",
                                marginBottom: 10,
                              }}
                            >
                              {Array.from({ length: totalSteps }).map(
                                (_, index) => (
                                  <View
                                    key={index}
                                    style={{
                                      height: 6,
                                      width: 6,
                                      borderRadius: 5,
                                      backgroundColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3 // Active step color
                                          : AppColors.white, // Inactive step color
                                      borderWidth: 1,
                                      borderColor:
                                        currentStep === index
                                          ? AppColors.appViolentColor_6D08C3 // Active step color
                                          : AppColors.white,
                                    }}
                                  />
                                )
                              )}
                            </View>

                            <Text
                              style={{
                                fontFamily: "Anybody_400Regular",
                                fontSize: 12,
                                color: AppColors.green_00FFE8,
                                marginBottom: 4,
                              }}
                            >
                              Click “Let’s Go” to stop tutorial.
                            </Text>
                            <TouchableOpacity
                              onPress={() => {
                                resetCreateEventTooltips();
                                handleNextStep();
                              }}
                              style={{
                                backgroundColor:
                                  AppColors.appViolentColor_6D08C3,
                                width: 70,
                                height: 20,
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 10,
                              }}
                            >
                              <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                Let’s Go
                              </Text>
                            </TouchableOpacity>
                          </View>
                        ) : (
                          <View style={{ marginTop: 10 }}>
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 10,
                                justifyContent: "space-between",
                              }}
                            >
                              {/* Dots (Step Indicator) */}
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 5,
                                  alignItems: "center",
                                }}
                              >
                                {Array.from({ length: totalSteps }).map(
                                  (_, index) => (
                                    <View
                                      key={index}
                                      style={{
                                        height: 6,
                                        width: 6,
                                        borderRadius: 5,
                                        backgroundColor:
                                          currentStep === index
                                            ? AppColors.appViolentColor_6D08C3
                                            : AppColors.white,
                                        borderWidth: 1,
                                        borderColor:
                                          currentStep === index
                                            ? AppColors.appViolentColor_6D08C3
                                            : AppColors.white,
                                      }}
                                    />
                                  )
                                )}
                              </View>

                              <TouchableOpacity
                                onPress={() => {
                                  resetCreateEventTooltips();
                                  handleNextStep();
                                }}
                                style={{
                                  backgroundColor:
                                    AppColors.appViolentColor_6D08C3,
                                  width: 70,
                                  height: 20,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: 10,
                                  cursor: "pointer",
                                }}
                              >
                                <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                  Let’s Go
                                </Text>
                              </TouchableOpacity>
                            </View>
                            <Text
                              style={{
                                fontFamily: "Anybody_400Regular",
                                fontSize: 12,
                                color: AppColors.green_00FFE8,
                                marginTop: 15,
                              }}
                            >
                              Click “Let’s Go” to stop tutorial.
                            </Text>
                          </View>
                        )}
                      </View>
                    </View>
                  }
                  placement="top"
                >
                  <TouchableHighlight>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.headerTitle,
                      ]}
                    >
                      Stream Settings
                    </Text>
                  </TouchableHighlight>
                </Tooltip>
              </View>
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_14, styles.headerTitle]}
              >
                Enable/disable
              </Text>
            </View>

            <View style={{ gap: 5 }}>
              {/* Chat */}
              {/* <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text
                  style={[AppFontStyle.REGULAR_ANYBODY_14, styles.lableStyle]}
                >
                  Chat
                </Text>
                <SwitchCommon
                  switchState={chatSwitch}
                  setSwitchState={setChatSwitch}
                />
              </View> */}
              {/* Comments */}
              {/* <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_14,
                          styles.lableStyle,
                        ]}
                      >
                        Comments
                      </Text>
                      <SwitchCommon
                        switchState={commentsSwitch}
                        setSwitchState={setCommentsSwitch}
                      />
                    </View> */}
              {/* Competitor */}
              {/* <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_14,
                          styles.lableStyle,
                        ]}
                      >
                        Competitor
                      </Text>
                      <SwitchCommon
                        switchState={competitorSwitch}
                        setSwitchState={setCompetitorSwitch}
                      />
                    </View> */}
              {/* All-or-Nothing Arena (winner takes all gifts) */}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <View style={{ flexDirection: "row" }}>
                  <Text
                    style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
                  >
                    All-or-Nothing Arena (winner takes all gifts)
                  </Text>
                  <TouchableOpacity
                    onPress={() => {
                      setTooltipForGift(!tooltipForGift);
                    }}
                  >
                    <Image
                      source={{ uri: AppImages.icInfo }}
                      style={{
                        height: 20,
                        width: 20,
                        resizeMode: "contain",
                      }}
                    />
                  </TouchableOpacity>
                  {tooltipForGift && (
                    <CreateEventTooltip
                      content={"All-or-Nothing Arena (winner takes all gifts)"}
                      maxHeight={100}
                      // content={tag.title}
                      visible={tooltipForGift}
                      setVisible={setTooltipForGift}
                    />
                  )}
                </View>
                <SwitchCommon
                  switchState={allOrNothingSwitch}
                  setSwitchState={setAllOrNothingSwitch}
                />
              </View>
            </View>
          </View>
        </View>

        <View style={styles.divider} />
      </View>
    </>
  );
};

export default PrivateEventCreateComponent;
